import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'

export default class SocialNetworkGroupModel extends BaseModel {
  static override constructorName = 'SocialNetworkGroupModel'

  public id: number = 0
  public name: string = ''
  public externalId: string = ''
  public url: string = ''
  public isEnabled: boolean = false
  public isAdded: boolean = false
  public isUserCanPost: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
